import { SDUIBannerTextContent } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Banner/__internal__/BannerTextContent/SDUIBannerTextContent";
import { BannerImages } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Banner/__internal__/ImageTextBanner/__internal__/BannerImages";
import {
  ImageTextBannerProps,
  ImageTextBannerVariant,
} from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Banner/__internal__/ImageTextBanner/__internal__/types";
import { Decorative } from "@faire/design-tokens";
import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { Flex } from "@faire/web/slate/Layout";
import { ResponsiveProp } from "@faire/web/slate/Theme/ResponsiveProp";
import { cn } from "@faire/web/tools/cn";
import React, { CSSProperties } from "react";

type ExternalFacingImageTextBannerType = Omit<ImageTextBannerProps, "variant">;
export const SDUIDefaultImageTextBannerRenderer = (
  props: ExternalFacingImageTextBannerType
) => {
  return <BaseSDUIImageTextBannerRenderer {...props} variant="left" />;
};

export const SDUIImageTextBannerRenderer = (
  props: ExternalFacingImageTextBannerType
) => {
  return <BaseSDUIImageTextBannerRenderer {...props} variant="right" />;
};

const BaseSDUIImageTextBannerRenderer = ({
  bannerComponent,
  loggingData,
  variant,
  renderBehaviour,
}: ImageTextBannerProps) => {
  const { images, responsive_images, style } = bannerComponent;

  const isAppDownload = bannerComponent?.app_download_phone_input_c_t_a_element;
  const overflow = isAppDownload ? "overflow-visible" : "overflow-hidden";

  return (
    <Flex
      className={cn("flex", overflow)}
      direction={getWrapperVariantDirection(variant)}
      style={{
        backgroundColor: getSlateColorToken(
          style?.background_color,
          Decorative.tint.neutral
        ),
      }}
      data-test-id="image-text-banner-renderer"
    >
      <BannerImages
        variant={variant}
        images={images}
        responsiveImages={responsive_images}
        renderBehaviour={renderBehaviour}
      />
      <SDUIBannerTextContent
        className="w-full justify-center px-4 py-8 md:p-12"
        bannerComponent={bannerComponent}
        loggingData={loggingData}
      />
    </Flex>
  );
};

const getWrapperVariantDirection = (
  variant: ImageTextBannerVariant
): ResponsiveProp<CSSProperties["flexDirection"]> => {
  switch (variant) {
    case "left":
      return {
        mobileAndAbove: "column",
        tabletAndAbove: "row",
      };
    case "right":
    default:
      return {
        mobileAndAbove: "column",
        tabletAndAbove: "row-reverse",
      };
  }
};
